module.exports = __webpack_public_path__ + "fasaw12.png?0ea02c4ca39f4a5711036c175969368b";